import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SERVER_BASE_URL } from '../constants';

import './LoginButtons.css';

const NaverLoginButton = () => {
    const clientId = process.env.REACT_APP_NAVER_CLIENT_ID;
    const apiKey = process.env.REACT_APP_X_API_KEY;
    const navigate = useNavigate();
    useEffect(() => {
        let naverLogin = new window.naver.LoginWithNaverId({
            clientId: clientId,
            callbackUrl: 'https://main.d2o2merhkuinz7.amplifyapp.com',
            loginButton: { color: "green", type: 3, height: "43" },
        });
        naverLogin.init();
        // naverLogin.getLoginStatus((status) => {
        //     if (status) {
        //         let userId = naverLogin.user.email + "-N";
        //         console.log(userId);
        //     }
        // })


        try {
            naverLogin.getLoginStatus((status) => {
                if (status) {
                    let userId = naverLogin.user.email + "-N";
                    console.log(userId);
                    navigate('/n-auth')

                    //                     fetch(`${SERVER_BASE_URL}/sign-in`, {
                    //                         method: 'POST',
                    //                         headers: {
                    //                             'Content-Type': 'application/json',
                    //                             'x-api-key': apiKey,
                    //                         },
                    //                         body: JSON.stringify({ 'user_id': userId }),
                    //                     })
                    //                         .then(response => {
                    //                             if (response.ok) {
                    //                                 return response.json();
                    //                             } else if (response.status === 404) {
                    //                                 alert('회원정보가 존재하지 않습니다.');
                    // 
                    // 
                    //                             } else {
                    //                                 throw new Error('Network response was not ok.');
                    //                             }
                    //                         })
                    //                         .then(data => {
                    //                             console.log('Success:', data);
                    //                             const authToken = data.authorization_token;
                    //                             localStorage.setItem('authorization_token', authToken);
                    //                             navigate('/main');
                    //                         })
                    //                         .catch(error => {
                    //                             console.error('Error:', error);
                    //                         });
                }
            });
        } catch (err) {
            console.log(err);
        }
    },);

    return (
        <div className="connect">
            <div id="naverIdLogin" />
        </div>
    );
};

export default NaverLoginButton;
